import InlineMessage from "./InlineMessage.mjs";
export * from "./InlineMessage.mjs";
export * from "./InlineMessageHeading.mjs";
var lib_default = InlineMessage;
export {
  lib_default as default
};
